module.exports = __webpack_public_path__ + "img/escape.4e980280.svg";